import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import { api } from '../../common/utils/api';
const REASONS = ['ip_dmca', 'prohibited', 'misleading', 'malware', 'other'];
/**
 * Formulário de denúncia de produto: motivo (allowlist) + detalhes opcionais.
 * Envia para /marketplace/products/{id}/report. O backend bloqueia duplicata
 * pendente do mesmo denunciante.
 */
export default class ReportProductModal extends Modal {
  reason = 'ip_dmca';
  details = '';
  submitting = false;
  className() {
    return 'Modal--small ReportProductModal';
  }
  title() {
    return this.t('title');
  }
  t(k, vars) {
    return app.translator.trans('ramon-marketplace.forum.report.' + k, vars);
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, this.t('reason_label')), m("select", {
      className: "FormControl",
      "aria-label": this.t('reason_label'),
      value: this.reason,
      onchange: e => {
        this.reason = e.target.value;
      }
    }, REASONS.map(r => m("option", {
      key: r,
      value: r
    }, this.t('reason_' + r))))), m("div", {
      className: "Form-group"
    }, m("label", null, this.t('details_label')), m("textarea", {
      className: "FormControl",
      rows: "4",
      value: this.details,
      placeholder: this.t('details_placeholder'),
      oninput: e => {
        this.details = e.target.value;
      }
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "button",
      className: "Button Button--primary Button--block",
      loading: this.submitting,
      onclick: e => this.onsubmit(e)
    }, this.t('submit')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.submitting = true;
    api('POST', `/marketplace/products/${this.attrs.productId}/report`, {
      reason: this.reason,
      details: this.details
    }).then(() => {
      app.alerts.show({
        type: 'success'
      }, this.t('sent'));
      this.hide();
    }).catch(err => {
      this.submitting = false;
      const code = err?.response?.error;
      const msg = code === 'already_reported' ? this.t('error_already_reported') : this.t('error_generic');
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/ReportProductModal', ReportProductModal);